import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import '../../stylesheet/tabdesign.css';
import AuthNavbar from '../navigation/authnavigation.jsx';

import CardRequestComp from './requestcardcomp.jsx';
const mapStateToProps = state =>
    ({
        optionState: state.selectedTabReducer.selectedTabReducer,
        cardState: state.getCardReducer.cardState,
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchSelectedTab(selectedOption) {
            dispatch(
                actions.selectedtabAction(selectedOption)
            )
        },
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        },
    })

class RequestCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: localStorage.getItem('taboption') || "tab5"
        }
    }
    handleChange(e) {
        this.setState({
            selectedOption: e.target.value
        })
    }
    componentWillMount() {
        this.props.fetchSelectedTab(this.state.selectedOption)
    }
    componentDidMount() {
        localStorage.setItem("comp", "profilecomp")
        this.setState({
            selectedOption: localStorage.getItem('taboption')
        })
     
  


     }
  
    callBack() {
        this.setState({
            selectedOption: localStorage.getItem('taboption')
        })
    }

    render() {      
       
        var cardTypes = localStorage.getItem('cardTypes')
      
        return (
            <div  className="row">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                 style={{ zIndex: 999999 }}
                pauseOnHover
            />
                <div className="col-md-12 m-0 p-0">
                    <AuthNavbar />
                </div>

                <div className="container" style={{ }}>
                    <div className="row pb-5">
                        <CardRequestComp />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestCard);


// WEBPACK FOOTER //
// ./src/components/myprofile/requestcard.jsx